import { createContext } from 'react';

import { ThemeContextType } from 'types';

export default createContext<ThemeContextType>({} as ThemeContextType);
